import { Link } from 'react-router-dom';
import { siteConfig } from '../../../../mocks/siteData';

interface Service {
  slug: string;
  name: string;
  fullDesc: string;
  icon: string;
  image: string;
  benefits: string[];
}

interface ServiceDetailServicesProps {
  service: Service;
}

export default function ServiceDetailServices({ service }: ServiceDetailServicesProps) {
  return (
    <section className="py-28 px-6 lg:px-12 xl:px-16 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-10 h-px bg-gold" />
          <span className="text-gold text-[10px] font-sans tracking-[0.35em] uppercase font-semibold">Service Overview</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Left — Text */}
          <div>
            <h2 className="font-serif text-white text-4xl lg:text-5xl font-bold leading-tight mb-6">
              {service.name}
            </h2>
            <p className="text-white/50 text-base font-sans leading-relaxed mb-10">
              {service.fullDesc}
            </p>

            <div className="mb-10">
              <h3 className="text-white/30 text-[10px] font-sans tracking-[0.3em] uppercase font-semibold mb-6">
                What's Included
              </h3>
              <ul className="flex flex-col gap-4">
                {service.benefits.map((b, i) => (
                  <li key={i} className="flex items-start gap-4">
                    <div className="w-6 h-6 flex items-center justify-center border border-gold/30 bg-gold/8 shrink-0 mt-0.5">
                      <i className="ri-check-line text-gold text-xs" />
                    </div>
                    <span className="text-white/60 text-sm font-sans leading-relaxed">{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <Link
              to="/services"
              className="inline-block bg-gold hover:bg-gold-light text-[#0A0A0A] font-sans font-semibold text-sm px-8 py-4 uppercase tracking-widest transition-colors cursor-pointer whitespace-nowrap"
            >
              Request {service.name} Support
            </Link>
          </div>

          {/* Right — Image + CTA */}
          <div>
            <div className="relative overflow-hidden mb-8">
              <div className="w-full h-80">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/60 to-transparent" />
            </div>

            <div className="border border-gold/15 p-7 bg-gold/3">
              <div className="w-10 h-10 flex items-center justify-center border border-gold/30 bg-gold/8 mb-5">
                <i className={`${service.icon} text-gold text-lg`} />
              </div>
              <h3 className="font-serif text-white text-lg font-semibold mb-3">
                Ready to Deploy This Program?
              </h3>
              <p className="text-white/40 text-sm font-sans leading-relaxed mb-6">
                OTT operates across all 50 states with a national crew infrastructure ready to support your next {service.name.toLowerCase()} program.
              </p>
              <div className="flex flex-col gap-3">
                <Link
                  to="/services"
                  className="block text-center bg-gold hover:bg-gold-light text-[#0A0A0A] font-sans font-semibold text-sm px-6 py-3 uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap"
                >
                  Get a Custom Event Quote
                </Link>
                <a
                  href={siteConfig.phoneHref}
                  className="block text-center border border-white/15 hover:border-white/30 text-white/50 hover:text-white font-sans text-sm px-6 py-3 uppercase tracking-wide transition-colors cursor-pointer whitespace-nowrap"
                >
                  {siteConfig.phone}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
